const RATE_DECIMALS = 4;

export const formatRate = (rate?: string | number | null): string | null => {
  if (rate === null || rate === undefined || rate === '') return null;
  const numeric = parseFloat(String(rate).replace('%', ''));

  if (Number.isNaN(numeric)) return null;

  return `${numeric.toFixed(RATE_DECIMALS)}%`;
};
